import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ListView } from '../../list-view/list-view';
import { IngredientsService } from '../../shared/services/ingredints-service';
import { HttpClient } from '@angular/common/http';
import { EnvironmentUrl } from '../../shared/services/environment-url';

@Component({
  selector: 'app-ingredients',
  imports: [ListView],
  templateUrl: './ingredients.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ingredients.css',
})
export class Ingredients {
  ingredientsService?: IngredientsService;

  constructor(
    private http: HttpClient,
    private envUrl: EnvironmentUrl,
  ) {
    this.ingredientsService = new IngredientsService(this.http, this.envUrl);
  }
}
